import React from "react";
import styles from "./styles.css";
import PropTypes from "prop-types";
import { Helmet } from "react-helmet-async";
import LeadFormAndWidgetWrapper from "../lead-form-and-widget-wrapper";
import getFileExtension from "../../../utils/helpers/get-file-extension";
import homePageBanner from "./images/home-page-banner.png";
import { Text } from "@cars24/turbo-web/lib/text";
import { useTokens } from "@cars24/turbo-web/lib/theme-provider";

const LuxuryCarsHomeBanner = ({
    ctaText,
    isBrandsVisible = true,
    children,
    isAllianceOffer = false,
    cmsData
}) => {
    const { tokens } = useTokens();
    const {landingBanner = {}, title = "Sell assured, sell Elite", subTitle = "Sell your premium car at the right value!", description = "Experience elite service, swift negotiations, and seamless transactions."} = cmsData || {};
    const {
        backgroundImage: image = {}
    } = landingBanner || {};

    const { url = homePageBanner } = image || {};
    return (
        <React.Fragment>
            <Helmet>
                <link
                    rel="preload"
                    as={"image"}
                    href={url}
                    type={`image/${getFileExtension(url)}`}
                    fetchpriority="high"
                    media="(min-width: 1440px)"
                />
            </Helmet>
            <div styleName={"styles.bannerWrappr"}>
                <img styleName={"styles.banner"} width="1440" height="888" src={url} alt="home banner" fetchpriority="high" />
                <div styleName={"styles.bannerTextWrapper"}>
                    <div styleName={"styles.offerText"}>
                        <div styleName={"styles.sellTitle"}>
                            <Text
                                align="right"
                                as="p"
                                fontWeight="semibold"
                                size="200"
                                transform="none"
                                color={tokens.text_default_text_disabled}
                            >
                                {title}
                            </Text>
                        </div>
                        <div styleName={"styles.bannerText"}>
                            <Text
                                align="left"
                                as="p"
                                fontWeight="semibold"
                                size="750"
                                transform="none"
                                color={tokens.text_default_text_inverse}
                            >
                                {subTitle}
                            </Text>
                            <Text
                                align="left"
                                as="p"
                                fontWeight="regular"
                                size="400"
                                transform="none"
                                color={tokens.text_default_text_disabled}
                            >
                                {description}
                            </Text>
                        </div>
                        {children && children}
                    </div>
                    <div styleName={"styles.leadFormWrapper"}>
                        <LeadFormAndWidgetWrapper ctaText={ctaText} isBrandsVisible={isBrandsVisible} isAllianceOffer={isAllianceOffer} isLuxuryPage />
                    </div>
                </div>
            </div>
        </React.Fragment>
    );
};

LuxuryCarsHomeBanner.propTypes = {
    mainHeading: PropTypes.string,
    ctaText: PropTypes.string,
    homePageBanner: PropTypes.string,
    isBrandsVisible: PropTypes.bool,
    children: PropTypes.any,
    isAllianceOffer: PropTypes.bool,
    heroImageSubTitleList: PropTypes.array,
    cmsData: PropTypes.object
};

export default LuxuryCarsHomeBanner;

